import React from "react";

// Simple SVG silhouette per tier. Body shape unchanged; tier expressed by label and stroke intensity.
const TIERS = {
  Male: [
    { pct: 10, label: "Very lean", desc: "Sharp abs, vascular." },
    { pct: 15, label: "Fit", desc: "Athletic, some ab lines." },
    { pct: 20, label: "Average", desc: "Slight softness at waist." },
    { pct: 25, label: "Soft", desc: "Rounder midsection." },
    { pct: 30, label: "High", desc: "Noticeable belly, no definition." },
  ],
  Female: [
    { pct: 16, label: "Very lean", desc: "Muscle striations visible." },
    { pct: 22, label: "Fit", desc: "Athletic curves, some tone." },
    { pct: 28, label: "Average", desc: "Healthy, soft curves." },
    { pct: 33, label: "Soft", desc: "Rounder hips and midsection." },
    { pct: 38, label: "High", desc: "Softer overall composition." },
  ],
};

function Body({ selected, tier }) {
  const stroke = selected ? "var(--lime)" : "#333";
  // scale width by tier for visual differentiation
  const widthFactor = 0.9 + tier.pct / 100;
  return (
    <svg viewBox="0 0 60 120" width="60" height="120">
      <ellipse cx="30" cy="15" rx="7" ry="8" fill="none" stroke={stroke} strokeWidth="1.5" />
      <path d={`M${30 - 10 * widthFactor},28 Q30,22 ${30 + 10 * widthFactor},28 L${30 + 8 * widthFactor},60 Q30,68 ${30 - 8 * widthFactor},60 Z`} fill="none" stroke={stroke} strokeWidth="1.5" />
      <line x1={30 - 4} y1="68" x2={30 - 5} y2="115" stroke={stroke} strokeWidth="1.5" />
      <line x1={30 + 4} y1="68" x2={30 + 5} y2="115" stroke={stroke} strokeWidth="1.5" />
    </svg>
  );
}

export default function SilhouettePicker({ gender, value, onChange }) {
  const tiers = TIERS[gender] || TIERS.Male;
  return (
    <div className="flex flex-col gap-3" data-testid="silhouette-picker">
      <div className="flex gap-3 overflow-x-auto snap-x px-1 pb-2">
        {tiers.map((t) => {
          const sel = value === t.pct;
          return (
            <button key={t.pct} onClick={() => onChange(t.pct)}
              data-testid={`silhouette-${t.pct}`}
              className={`snap-start shrink-0 flex flex-col items-center gap-2 p-3 rounded-2xl border transition-colors ${sel ? "border-lime" : "border-hair"}`}
              style={{ background: sel ? "rgba(193,255,0,0.05)" : "transparent" }}>
              <Body selected={sel} tier={t} />
              <div className="text-center">
                <div className={`font-display text-xl tabular ${sel ? "text-lime" : "text-t1"}`}>{t.pct}%</div>
                <div className="overline mt-1">{t.label}</div>
              </div>
            </button>
          );
        })}
      </div>
      <p className="text-xs text-t3">Estimate only. For real accuracy, use tape or a DEXA scan.</p>
    </div>
  );
}
